export default __webpack_public_path__ + "static/kespa-desktop-a59558b6b8da4f5df63d9cfde8eb877a.mp4";